import getURLSearchParam from '../base/url'
import { baseURL } from './const'
import requestParams from './request-params'
import Agent from '../agent'
import appmock from './appmock'
import { isNodeProd, isEnvProd, liteset } from '../base/env'
import { CustomRequestConfig } from './types'

function configLiteSet(config: CustomRequestConfig) {
  // gray-release-ia-staff 内灰
  // gray-release-ia 百分比灰
  if (liteset) {
    config.headers!['M-Context'] = window.btoa(JSON.stringify({ INF_CELL: liteset }))
  }
  return config
}

function configCanary(config: CustomRequestConfig) {
  // console.log('req', 3)
  // 灰度
  // http://dev.sankuai.com/code/repo-detail/NIBFE/talos-canary-header/file/list
  if (window._AWP_DEPLOY_VERSION) {
    const isCanaryHost = (config.url || '').includes(baseURL)
    if (isCanaryHost) config.headers!['AWP-DEPLOY-VERSION'] = window._AWP_DEPLOY_VERSION
  }
  return config
}

function configParams(config: CustomRequestConfig) {
  // console.log('req', 2)
  if (
    getURLSearchParam('token') &&
    config.url !== '/user/api/v1/sso' &&
    (Agent.anyminiprogram || !isNodeProd() || !isEnvProd())
  ) {
    config.headers!['X-PHX-AUTH-TOKEN'] = getURLSearchParam('token')
  }
  config.params = requestParams
  config._startTime = Date.now()
  return config
}

function processUrl(config: CustomRequestConfig) {
  // console.log('req', 1)
  // 过滤外部接口
  if ((config.url || '').indexOf('http') === -1) {
    // 使用 proxy
    if (!isNodeProd() && ((config.url || '').indexOf('mock') !== -1 || getURLSearchParam('_mock_') === 'papi')) {
      config.url = window.location.origin + config.url
      console.log('[mock]', config.url)
    } else {
      const base_url = config.hitFlag ? config.baseURL : baseURL
      config.url = appmock(window.location.protocol + base_url + config.url)
    }
  }
  return config
}

export default async function processRequestConfig(config: CustomRequestConfig) {
  return configLiteSet(configCanary(configParams(processUrl(config))))
}
